<template>
  <div class="page-liuxuan-test-qa-page-2019"
       :style="clientHeight"
       ref="qaPage"
  >
    <div class="header">精准扶教家长群(7)</div>
    <system-tip v-if="showBlockCount >= 1"
                @addShowBlockCount="handleAddBlockCount"
    />
    <chat-left-block :list="prologue"
                     @addShowBlockCount="handleAddBlockCount"
                     v-if="showBlockCount >= 2"
    />
    <div class="start-block"
         v-if="showBlockCount >= 3"
         @click="handleClickStart"
    >
      <div class="start-btn block-box"
           v-ym-report:MARKETING_LIUXUAN_TEST_START_CLICK
      >开始</div>
      <chat-right class="answer"
                  content="开始"
                  v-if="showStartContent"
      />
      <audio ref="clickVoice"
             :src="require('@/pages/2019/LiuXuanTest/assets/click-voice.mp3')"
             preload="auto"
      ></audio>
    </div>
    <chat-left-block :list="chatA"
                     @addShowBlockCount="handleAddBlockCount"
                     v-if="showBlockCount >= 4"
    />
    <chat-question :content="questionA.content"
                   :options="questionA.options"
                   index="questionA"
                   v-if="showBlockCount >= 5"
                   @score="handleCalculateScore"
                   @addShowBlockCount="handleAddBlockCount"
    />
    <chat-left-block :list="chatB"
                     @addShowBlockCount="handleAddBlockCount"
                     v-if="showBlockCount >= 6"
    />
    <chat-question :content="questionB.content"
                   :options="questionB.options"
                   index="questionB"
                   v-if="showBlockCount >= 7"
                   @score="handleCalculateScore"
                   @addShowBlockCount="handleAddBlockCount"
    />
    <chat-left-block :list="chatC"
                     @addShowBlockCount="handleAddBlockCount"
                     v-if="showBlockCount >= 8"
    />
    <chat-question :content="questionC.content"
                   :options="questionC.options"
                   index="questionC"
                   v-if="showBlockCount >= 9"
                   @score="handleCalculateScore"
                   @addShowBlockCount="handleAddBlockCount"
    />
    <chat-left-block :list="chatD"
                     @addShowBlockCount="handleAddBlockCount"
                     v-if="showBlockCount >= 10"
    />
    <chat-question :content="questionD.content"
                   :options="questionD.options"
                   index="questionD"
                   v-if="showBlockCount >= 11"
                   @score="handleCalculateScore"
                   @addShowBlockCount="handleAddBlockCount"
    />
    <chat-left-block :list="chatE"
                     @addShowBlockCount="handleAddBlockCount"
                     v-if="showBlockCount >= 12"
    />
    <chat-question :content="questionE.content"
                   :options="questionE.options"
                   index="questionE"
                   v-if="showBlockCount >= 13"
                   @score="handleCalculateScore"
                   @addShowBlockCount="handleAddBlockCount"
    />
    <chat-left-block :list="chatF"
                     @addShowBlockCount="handleAddBlockCount"
                     v-if="showBlockCount >= 14"
    />
    <chat-question :content="questionF.content"
                   :options="questionF.options"
                   index="questionF"
                   v-if="showBlockCount >= 15"
                   @score="handleCalculateScore"
                   @addShowBlockCount="handleAddBlockCount"
    />
    <chat-left-block :list="chatG"
                     status="end"
                     @addShowBlockCount="handleAddBlockCount"
                     v-if="showBlockCount >= 16"
    />
    <div id="page-end"></div>
  </div>
</template>
<script>
  import SystemTip from '@/pages/2019/LiuXuanTest/components/SystemTip';
  import ChatLeftBlock from '@/pages/2019/LiuXuanTest/components/ChatLeftBlock';
  import ChatRight from '@/pages/2019/LiuXuanTest/components/ChatRight';
  import ChatQuestion from '@/pages/2019/LiuXuanTest/components/ChatQuestion';

  export default {
    name: 'LiuXuanTestQAPage2019',
    components: {
      SystemTip,
      ChatLeftBlock,
      ChatRight,
      ChatQuestion,
    },
    props: {
      name: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        prologue: [
          {
            /* eslint-disable global-require */
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/liuxuan.png'),
            name: '刘轩',
            nickName: '（著名心理学学者）',
            content: 'HEY, 欢迎新来的家长',
            type: 'ChatLeft',
          },
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/fangyuan.png'),
            name: '方圆',
            nickName: '（方一凡家长）',
            content: '欢迎！欢迎！',
            type: 'ChatLeft',
          },
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/songqian.png'),
            name: '宋倩',
            nickName: '（乔英子家长）',
            emoji: [
              require('@/pages/2019/LiuXuanTest/assets/img/applaud.png'),
              require('@/pages/2019/LiuXuanTest/assets/img/applaud.png'),
              require('@/pages/2019/LiuXuanTest/assets/img/applaud.png'),
            ],
            type: 'ChatLeft',
          },
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/liuxuan.png'),
            name: '刘轩',
            nickName: '（著名心理学学者）',
            content: '孩子的所有问题其实都是性格问题哦',
            type: 'ChatLeft',
          },
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/liuxuan.png'),
            name: '刘轩',
            nickName: '（著名心理学学者）',
            content: '来跟群里的代表家长们，一起聊聊孩子成长中遇到的那些小问题，开始更了解你的孩子吧。',
            type: 'ChatLeft',
          },
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/liuxuan.png'),
            name: '刘轩',
            nickName: '（著名心理学学者）',
            content: '记得认真选择哦，让我们开始吧',
            type: 'ChatLeft',
          },
        ],
        chatA: [
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/liumei.png'),
            name: '刘梅',
            nickName: '（刘星家长）',
            content: '气死我了，我们家孩子经常抵不住诱惑，刚刚跟他吵了一架。话说你们家孩子怎么样？',
            type: 'ChatLeft',
          },
        ],
        questionA: {
          content: '1.如果，你叫孩子去打酱油，如果酱油店旁边有个冰激凌店，ta会怎么做？',
          type: 'img',
          options: [
            {
              img: require('@/pages/2019/LiuXuanTest/assets/img/q1_op1.png'),
              desc: 'A.吃了冰激凌，忘了酱油瓶',
              score: 3,
            },
            {
              img: require('@/pages/2019/LiuXuanTest/assets/img/q1_op2.png'),
              desc: 'B.只买酱油瓶，不被外部势力所惑',
              score: 1,
            },
            {
              img: require('@/pages/2019/LiuXuanTest/assets/img/q1_op3.png'),
              desc: 'C.孩子买到啥我都不在乎，这很正常',
              score: 5,
            },
          ],
        },
        chatB: [
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/liuxuan.png'),
            name: '刘轩',
            nickName: '（著名心理学学者）',
            content: '专心的范围有限，有些还是「专注力误导」呢。',
            type: 'ChatLeft',
          },
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/songqian.png'),
            name: '宋倩',
            nickName: '（乔英子家长）',
            content: '哎，我们家孩子啥都行，就是记性不太好。',
            type: 'ChatLeft',
          },

        ],
        questionB: {
          content: '2.如果说金鱼的记忆只有5秒，那你觉得你的孩子记忆是几秒？',
          type: 'text',
          options: [
            {
              desc: 'A.0秒，连鱼都不如',
              score: 3,
            },
            {
              desc: 'B.永恒，太可怕了这个记忆力',
              score: 5,
            },
            {
              desc: 'C.20秒或以上，比金鱼强一点点',
              score: 1,
            },
          ],
        },
        chatC: [
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/liuxuan.png'),
            name: '刘轩',
            nickName: '（著名心理学学者）',
            content: '其实我们的大脑只会记住重点讯息',
            type: 'ChatLeft',
          },
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/jishengli.png'),
            name: '季胜利',
            nickName: '（季杨杨的父亲）',
            content: '真羡慕记忆好的孩子，话说现在的孩子不仅记忆力差了点，还特别的娇生惯养',
            type: 'ChatLeft',
          },
        ],
        questionC: {
          content: '你的孩子摊上大事了的时候一般会怎么办？',
          type: 'img',
          options: [
            {
              img: require('@/pages/2019/LiuXuanTest/assets/img/q3_op1.png'),
              desc: 'A.认怂，忍气吞声',
              score: 1,
            },
            {
              img: require('@/pages/2019/LiuXuanTest/assets/img/q3_op2.png'),
              desc: 'B.哭着找妈妈',
              score: 3,
            },
            {
              img: require('@/pages/2019/LiuXuanTest/assets/img/q3_op3.png'),
              desc: 'C.不怕事，非常稳',
              score: 5,
            },
          ],
        },
        chatD: [
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/liuxuan.png'),
            name: '刘轩',
            nickName: '（著名心理学学者）',
            content: '「个性」就像指纹一样，每个人都是个独一无二的组合',
            type: 'ChatLeft',
          },
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/xiadonghai.png'),
            name: '夏东海',
            nickName: '（刘梅丈夫）',
            content: '刚刚还因为孩子偷懒没写作业，孩子他妈跟我吵了一架',
            type: 'ChatLeft',
          },
        ],
        questionD: {
          content: '4.话说,你的孩子做作业时候的拖延等级是怎样的?',
          type: 'slide',
          options: [
            {
              desc: 'I',
              score: 5,
            },
            {
              desc: 'II',
              score: 5,
            },
            {
              desc: 'III',
              score: 3,
            },
            {
              desc: 'IV',
              score: 1,
            },
            {
              desc: 'V',
              score: 1,
            },
          ],
        },
        chatE: [
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/jishengli.png'),
            name: '季胜利',
            nickName: '（季杨杨的父亲）',
            content: '还是@方圆 的孩子培养的好，听说考上南京大学啦？恭喜啊',
            type: 'ChatLeft',
          },
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/fangyuan.png'),
            name: '方圆',
            nickName: '（方一凡家长）',
            content: '谢谢，太客气了，其实很多孩子的习惯要点滴培养。',
            emoji: [
              require('@/pages/2019/LiuXuanTest/assets/img/smile.png'),
            ],
            type: 'ChatLeft',
          },
        ],
        questionE: {
          content: '5.你会注重培养孩子早睡早起，随手关灯、洗手之类的小细节/好习惯吗？',
          type: 'text',
          options: [
            {
              desc: 'A.会，这个意愿强烈',
              score: 5,
            },
            {
              desc: 'B.散养，姐/哥不管',
              score: 3,
            },
            {
              desc: 'C.把分数拿过来再说',
              score: 1,
            },
          ],
        },
        chatF: [
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/liuxuan.png'),
            name: '刘轩',
            nickName: '（著名心理学学者）',
            content: '@xxx家长真的太受欢迎了，相信你的孩子也跟你一样吧。',
            type: 'ChatLeft',
          },
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/liuxuan.png'),
            name: '刘轩',
            nickName: '（著名心理学学者）',
            content: '我在少年商学院开设了《刘轩给孩子的心理学课》，给孩子普及心理学知识！让家长更了解孩子！',
            type: 'ChatLeft',
          },
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/fangyuan.png'),
            name: '方圆',
            nickName: '（方一凡家长）',
            content: '咳！本群禁止打广告！',
            type: 'ChatLeft',
          },
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/liuxuan.png'),
            name: '刘轩',
            nickName: '（著名心理学学者）',
            content: ' …………',
            emoji: [
              require('@/pages/2019/LiuXuanTest/assets/img/blush.png'),
            ],
            type: 'ChatLeft',
          },
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/liuxuan.png'),
            name: '刘轩',
            nickName: '（著名心理学学者）',
            content: '别走开，最后一个问题很有趣哦',
            type: 'ChatLeft',
          },
        ],
        questionF: {
          content: '6、当孩子看到其他孩子有零食，但是自己没有的时候，生气哭闹了，你会怎么做？',
          type: 'text',
          options: [
            {
              desc: 'A.跟孩子讲道理，晓之以情，动之以理',
              score: 5,
            },
            {
              desc: 'B.禁止闹事，否则从严处理',
              score: 3,
            },
            {
              desc: 'C.一脸懵逼，当孩子的吃瓜群众',
              score: 1,
            },
          ],
        },
        chatG: [
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/liuxuan.png'),
            name: '刘轩',
            nickName: '（著名心理学学者）',
            emoji: [
              require('@/pages/2019/LiuXuanTest/assets/img/applaud.png'),
              require('@/pages/2019/LiuXuanTest/assets/img/applaud.png'),
              require('@/pages/2019/LiuXuanTest/assets/img/applaud.png'),
            ],
            type: 'ChatLeft',
          },
          {
            avatar: require('@/pages/2019/LiuXuanTest/assets/img/liuxuan.png'),
            name: '刘轩',
            nickName: '（著名心理学学者）',
            content: '恭喜你完成了全部的测试题',
            type: 'ChatLeft',
          },
        ],
        /* eslint-enable global-require */

        score: 0,
        showBlockCount: 1,
        startDisabled: false,
        showStartContent: false,
      };
    },
    computed: {
      clientHeight() {
        const result = {};
        result['min-height'] = `${document.body.clientHeight}px`;
        return result;
      },
    },
    methods: {
      handleCalculateScore(data) {
        this.score += data;
      },
      handleAddBlockCount(status) {
        if (status === 'end') {
          this.$emit('score', this.score);
        } else {
          this.showBlockCount += 1;
        }
      },
      handleClickStart() {
        if (this.startDisabled) return;
        this.startDisabled = true;
        this.showStartContent = true;
        this.$refs.clickVoice.play();
        this.handleAddBlockCount();
      },
    },
    created() {
      this.chatF[0].content = `@${this.name}家长 真的太受欢迎了，相信你的孩子也跟你一样吧。`;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-liuxuan-test-qa-page-2019 {
    min-height: 100%;
    padding: 0 0 @size-large 0;
    box-sizing: border-box;
    background: @color-white;
  }

  .header {
    margin-bottom: @size-large;
    padding: 28px 0;
    font-size: 30px;
    color: #333;
    text-align: center;
    background: #f2f2f2;
  }

  .block-hide {
    display: none;
  }

  .block-box {
    min-height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 35px;
    font-size: 26px;
    color: @color-white;
    background: #333;
    box-shadow: 0 2px 15px 0 rgba(71, 159, 157, 0.3);
  }

  #page-end {
    position: relative;
    z-index: 1;
    content: '';
    padding-top: 100px;
  }

  .start-block {
    position: relative;
    z-index: 2;
    padding-bottom: @size-extra-medium;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .block-box {
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 35px;
      font-size: 26px;
      color: @color-white;
      background: #333;
      box-shadow: 0 2px 15px 0 rgba(71, 159, 157, 0.3);
    }
    .start-btn {
      width: 234px;
      text-align: center;
    }
    .answer {
      margin-top: @size-extra-medium;
    }
  }

</style>
